import src from "IMAGE";
export default { src, width: 483, height: 494, blurWidth: 0, blurHeight: 0};
